import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

import { loadMessages, locale } from 'devextreme/localization';
import esMessages from 'devextreme/localization/messages/es.json';

loadMessages(esMessages);
locale('es');

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
